
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/pendo",
      function () {
        return require("private-next-pages/destinations/pendo.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/pendo"])
      });
    }
  